export default function ElementsPage() {
	return (
		<div>
			🚧 Under construction 🚧
		</div>
	)
}
